import React, { useState, useEffect } from "react";
import SessionForm from "../components/SessionForm";
import SessionTable from "../components/SessionTable";
import { useUser } from "../contexts/UserContext";

const SessionPage = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [apps, setApps] = useState([]);
  const [sessions, setSessions] = useState([]);
  const { user } = useUser();

  const fetchData = async () => {
    try {
      if (!user?.id) return; // Don't fetch if there's no user

      const appsResponse = await fetch(`${API_BASE_URL}apps/${user.id}`);
      const appsData = await appsResponse.json();
      setApps(appsData);

      const sessionsResponse = await fetch(
        `${API_BASE_URL}sessions/${user.id}`
      );
      const sessionsData = await sessionsResponse.json();
      setSessions(sessionsData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  const handleNewSession = async (sessionData) => {
    try {
      const enrichedSessionData = {
        ...sessionData,
        userId: user.id,
      };

      const response = await fetch(`${API_BASE_URL}sessions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enrichedSessionData),
      });
      const newSession = await response.json();

      // Find corresponding app and add its details
      const appId = apps.find((app) => app._id === newSession.appId);
      const sessionWithApp = { ...newSession, appId };

      setSessions([sessionWithApp, ...sessions]);
    } catch (error) {
      console.error("Error creating session:", error);
    }
  };

  const handleUpdateSession = async (updatedData) => {
    console.log('updatedData', updatedData);

    try {
      const response = await fetch(`${API_BASE_URL}sessions/updateSessions`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });
      await response.json();
      fetchData();
    } catch (error) {
      console.error("Error updating session:", error);
    }
  };

  const handleDeleteSession = async (sessionId) => {
    try {
      await fetch(`${API_BASE_URL}sessions/${sessionId}`, {
        method: "DELETE",
      });
      setSessions(sessions.filter((session) => session._id !== sessionId));
    } catch (error) {
      console.error("Error deleting session:", error);
    }
  };

  return (
    <div
      className="p-6"
      style={{ backgroundColor: "#C6D2ED", minHeight: "100vh" }}
    >
      <div className="mb-6">
        <SessionForm apps={apps} onSubmit={handleNewSession} />
      </div>
      <div>
        <SessionTable
          sessions={sessions}
          apps={apps}
          onUpdateSession={handleUpdateSession}
          onDeleteSession={handleDeleteSession}
        />
      </div>
    </div>
  );
};

export default SessionPage;
